import { DEFAULT_AREA_ID, DEFAULT_CITY_ID } from "GlobalConstant/Location";
import ApiCalls from "GlobalUtils/ApiCalls";
const SUBSCRIPTION_CATEGORY = 1;

export const getModelPageData = (
  makeMaskingName,
  modelMaskingName,
  cityId,
  areaId,
  showOfferUpfront,
  platformId
) => {
  return ApiCalls.fetchApi({
    url: "/api/modelpagedata/",
    options: {
      makeMaskingName: makeMaskingName || "",
      modelMaskingName: modelMaskingName || "",
      cityId: cityId || DEFAULT_CITY_ID,
      areaId: areaId || DEFAULT_AREA_ID,
      showOfferUpfront: showOfferUpfront || false,
      platformId: platformId,
    },
  });
};
export const subscribeEmail = (email, modelId) => {
  return ApiCalls.fetchApi({
    url: "/api/subscribe/",
    requestInit: {
      method: "POST",
      body: `{"Email":"${email}","Category":"${SUBSCRIPTION_CATEGORY}","Type":"${modelId}"}`,
      headers: new Headers({
        "content-type": "application/json",
      }),
    },
  });
};
